import { render, staticRenderFns } from "./aplicacion-nomina-resumen.vue?vue&type=template&id=150f7e26&"
import script from "./aplicacion-nomina-resumen.vue?vue&type=script&lang=ts&"
export * from "./aplicacion-nomina-resumen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports